import React, { useState } from 'react'


export default function ShadowWorkForm(props) {
    let questions = props.questions

    // for each question, we can make a question card
    

    return(
        <div>
            Shadow Work Form
        </div>
    )
}